import { render, staticRenderFns } from "./TwentyNineTable.vue?vue&type=template&id=3889c120&"
import script from "./TwentyNineTable.vue?vue&type=script&lang=js&"
export * from "./TwentyNineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports